import { Component } from '@angular/core';

@Component({
    templateUrl: '500.component.html',
    standalone: false
})
export class P500Component {
  constructor() {}
}
